import { Pagination } from "flowbite-react";
import React from "react";

export default function GaleryRegularContent() {
  const onPageChange = 0;

  return (
    <div className="container flex justify-center items-center mt-20 mb-20">
      <div className="w-3/4">
        <div className="flex justify-center">
          <p className="text-lg mr-5 text-lime-700 font-bold">All</p>
          <p className="text-lg mr-5">Architecture</p>
          <p className="text-lg mr-5">Interior</p>
          <p className="text-lg mr-5">Landscape</p>
          <p className="text-lg mr-5">Planning</p>
        </div>

        <div className="grid grid-cols-3 gap-4 mt-7">
          <div className="col-span-1">
            <img
              src={require("../../images/galery-1.jpg")}
              alt="Foto 1"
              className="w-full"
            />
          </div>
          <div className="col-span-1">
            <img
              src={require("../../images/galery-2.jpg")}
              alt="Foto 1"
              className="w-full"
            />
          </div>
          <div className="col-span-1">
            <img
              src={require("../../images/galery-3.jpg")}
              alt="Foto 1"
              className="w-full"
            />
          </div>
        </div>

        <div className="grid grid-cols-3 gap-4 mt-5">
          <div className="col-span-1">
            <img
              src={require("../../images/galery-4.jpg")}
              alt="Foto 1"
              className="w-full"
            />
          </div>
          <div className="col-span-1">
            <img
              src={require("../../images/galery-5.jpg")}
              alt="Foto 1"
              className="w-full"
            />
          </div>
          <div className="col-span-1">
            <img
              src={require("../../images/galery-6.jpg")}
              alt="Foto 1"
              className="w-full"
            />
          </div>
        </div>

        <div className="grid grid-cols-3 gap-4 mt-5">
          <div className="col-span-1">
            <img
              src={require("../../images/galery-7.jpg")}
              alt="Foto 1"
              className="w-full"
            />
          </div>
          <div className="col-span-1">
            <img
              src={require("../../images/galery-8.jpg")}
              alt="Foto 1"
              className="w-full"
            />
          </div>
          <div className="col-span-1">
            <img
              src={require("../../images/galery-9.jpg")}
              alt="Foto 1"
              className="w-full"
            />
          </div>
        </div>

        <div className="grid grid-cols-3 gap-4 mt-5">
          <div className="col-span-1">
            <img
              src={require("../../images/galery-10.jpg")}
              alt="Foto 1"
              className="w-full"
            />
          </div>
          <div className="col-span-1">
            <img
              src={require("../../images/galery-11.jpg")}
              alt="Foto 1"
              className="w-full"
            />
          </div>
          <div className="col-span-1">
            <img
              src={require("../../images/galery-12.jpg")}
              alt="Foto 1"
              className="w-full"
            />
          </div>
        </div>

        {/* Pagination */}
        <div className="flex justify-center items-center mt-10 mb-20">
          <Pagination
            currentPage={1}
            onPageChange={onPageChange}
            showIcons={true}
            totalPages={100}
          />
        </div>
        {/* End Pagination */}
      </div>
    </div>
  );
}
